module.exports = __webpack_public_path__ + "img/con-ser-icon.223ff6e6.png";